
import Glide from '@glidejs/glide';

/**
 * CaseStudies
 * @param  {[type]} options [description]
 * @return {[type]}         [description]
 */
var CaseStudies = function(options){

  this.options = {
    $el: false
  };

  $.extend(true, this.options, options);

  this.caseId = this.options.$el.data("case-studies-id");
  if(!this.caseId){
    this.caseId = 'caseId';
    this.options.$el.attr("data-case-studies-id", this.caseId);
  }


  this.$dots = this.options.$el.find(".dots-container a");
  this.$window = $(window);

};

/**
 * Init
 * @return {[type]} [description]
 */
CaseStudies.prototype.init = function(){

  var self = this;

  // init our carousel if we're not using the static layout
  if(this.$dots.length){
    setTimeout(function(){
      self.initCarousel();
    }, 250);

    // Add resize event listener to adjust slider on window resize
    var debouncedResize = _.debounce(function(){
      self.handleResize();
    }, 250);

    this.$window.on('resize', debouncedResize);

  }

};

/**
 * Handle window resize
 * @return {[type]} [description]
 */
CaseStudies.prototype.handleResize = function(){

  // Destroy existing carousel if it exists
  if(this.carousel){
    this.carousel.destroy();
  }

  // Reinitialize the carousel with new dimensions
  this.initCarousel();

};

/**
 * Init'ing our carousel
 * @return {[type]} [description]
 */
CaseStudies.prototype.initCarousel = function(){

  var self = this;
  var carouselSelector = '[data-case-studies-id=' + this.caseId + '] .glide';

  if(window.Breakpoint.value === "xsmall" || window.Breakpoint.value === "small"){

    this.carousel = new Glide(carouselSelector, {
      type: 'carousel',
      startAt: 0,
      perView: this.$window.width() > 700 ? 2 : 1,
      peek: 50
    });

  }else if(window.Breakpoint.value === "medium"){

    this.carousel = new Glide(carouselSelector, {
      type: 'carousel',
      startAt: 0,
      perView: this.$window.width() > 900 ? 2 : 1,
      peek: 50
    });
    

  }else{

    this.carousel = new Glide(carouselSelector, {
      type: 'carousel',
      startAt: 0,
      perView: this.$window.width() > 1700 ? 3 : 2,
      peek: 200
    });

  }

  // a method to update our dots if the carousl is dragged or moved
  var debouncedMove = _.debounce(function(){
    self.updateDots(self.carousel.index);
  }, 500);

  this.carousel.on('move', function(e) {
    debouncedMove();
  })

  // inits the carousel
  this.carousel.mount();

  // clicking on dots
  this.$dots.on("click", function(){
    var $el = $(this);
    var index = $el.index();
    self.carousel.go('=' + index);
    self.updateDots(index);
  })

}

/**
 * Updating our dot
 * @return {[type]} [description]
 */
CaseStudies.prototype.updateDots = function(index){

  this.$dots.removeClass("is-active");
  this.$dots.eq(index).addClass("is-active");

}

export default  CaseStudies;
